<ng-container *skAutorun><div class="edit-overlay" (click)="openContentEditor()">Edit content</div><div tabindex="1" [innerHTML]="html"></div></ng-container>